import React, { useEffect } from 'react';
import { Routes, Route, useNavigate, Navigate } from 'react-router-dom';
import ProtectedRoute from './services/ProtectedRoute';
import DashboardLayout from './layouts/DashboardLayout';
import DashboardHome from './pages/dashboard/DashboardHome';

import LoginPage from './pages/auth/LoginPage';
import RegistrationPage from './pages/auth/RegistrationPage';
import { useAuth } from './context/AuthContext';
import { setAppNavigator } from './services/navigation';
import { MembersListPage } from './pages/members/MembersListPage';

import FinancesPage from './pages/finances/FinancesPage';
import ReportsPage from './pages/finances/ReportsPage';
import AccountsListPage from './pages/accounts/AccountsListPage';
import MemberSettings from './pages/members/MemberSettingsPage';
import { useChurch } from './context/ChurchContext.tsx';

const App: React.FC = () => {
    const navigate = useNavigate();

    useEffect(() => {
        setAppNavigator(navigate);
    }, [navigate]);

    return (
        <div className="App">
            <Routes>
                {/* Landing Page as the root route */}
                <Route path="/" element={<Navigate to="/login" replace />} />

                {/* Public routes */}
                {/* Changed /signup to /register to match existing route name */}
                <Route path="/register" element={<RegistrationPage />} />
                <Route path="/login" element={<LoginPage />} />

                {/* Dashboard and its nested protected routes */}
                <Route
                    path="/dashboard"
                    element={
                        <ProtectedRoute roles={['member', 'admin', 'super-admin']}>
                            <DashboardLayout />
                        </ProtectedRoute>
                    }
                >
                    {/* Default content for /dashboard */}
                    <Route index element={<DashboardHome />} />

                    {/* Members Management Page (Admin/Super-Admin Only) */}
                    <Route path="members" element={
                        <ProtectedRoute roles={['admin', 'super-admin']}>
                            <MembersListPage />
                        </ProtectedRoute>
                    } />

                    {/* Finances Management Page (Admin/Super-Admin Only) */}
                    <Route path="finances" element={
                        <ProtectedRoute roles={['admin', 'super-admin']}>
                            <FinancesPage />
                        </ProtectedRoute>
                    } />

                    {/* Accounts Management Page (Super-Admin Only) */}
                    <Route path="accounts" element={
                        <ProtectedRoute roles={['super-admin']}>
                            <AccountsListPage />
                        </ProtectedRoute>
                    } />
                    {/* Accounts Management Page (Super-Admin Only) */}
                    <Route path="reports" element={
                        <ProtectedRoute roles={['super-admin']}>
                            <ReportsPage />
                        </ProtectedRoute>
                    } />
                    {/* User Settings Page (All Roles) */}
                    <Route path="settings" element={
                        <ProtectedRoute roles={['member', 'admin', 'super-admin']}>
                            <MemberSettings />
                        </ProtectedRoute>
                    } />

                    {/* Fallback for unknown dashboard sub-routes */}
                    <Route path="*" element={<p className="text-center mt-10 text-xl text-gray-600">Dashboard sub-page not found.</p>} />
                </Route>

                {/* Catch-all for any other unknown routes, redirecting to the landing page */}
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </div>
    );
};

export default App;

